<agpr-dialog-container
    [id]="'reportCreateDialog'"
    heading="Reports.createReport"
    [modal]="true"
    [draggable]="false"
    [contentPadding]="false"
    (close)="closeDialog()"
>
    <div class="agpr-reportCreateDialog-content">
        <agpr-tabs
            [selectedTabIndex]="selectedTabIndex"
            (selectedTabIndexChange)="tabChange($event)"
        >
            <agpr-tab
                [id]="'reportCreateDialog_quickReportTab'"
                *ngIf="showQuickReportOption"
                [heading]="'Reports.quickReport'"
                [icon]="'fa-kit-duotone fa-agpr-file-quick'"
            >
                <div class="agpr-reportCreateDialog-tabContent">
                    <div class="agpr-reportCreateDialog-newQuickReport"
                        [style.display]="secondStep ? 'none' : 'flex'">
                        <agpr-panel
                            class="agpr-reportCreateDialog-newQuickReport-reportTypeContainer"
                            header="Reports.selectReportType"
                            [toggleable]="false"
                            [contentPadding]="false"
                        >
                            <!--Select Report Type Buttons  -->
                            <div
                                class="agpr-reportCreateDialog-newQuickReport-reportTypeContainerContent"
                                role="group"
                                [attr.aria-label]="'Reports.selectReportType' | localize"
                            >
                                <button
                                    class="agpr-reportCreateDialog-reportTypeButton"
                                    id="reportCreateDialog.coverageReport"
                                    (click)="setCreateSingleSeriesReport(true)"
                                    [ngClass]="{'agpr-reportCreateDialog-reportTypeButton--active': createSingleSeriesReport && !createCustomReport }"
                                >
                                    <span
                                        class="agpr-reportCreateDialog-reportTypeButtonIcon">
                                        <span class="agpr-i-line-reports-coverage" aria-hidden="true"></span>
                                    </span>
                                    <div
                                        class="agpr-reportCreateDialog-reportTypeButtonFlexContainer"
                                        [ngClass]="{'agpr-reportCreateDialog-reportTypeButtonFlexContainer--active': createSingleSeriesReport && !createCustomReport }"
                                    >
                                        <span class="agpr-reportCreateDialog-reportTypeButtonLabel">
                                            {{ 'Reports.selectCoverageReport' | localize }}
                                        </span>
                                        <span class="agpr-reportCreateDialog-reportTypeButtonText">
                                            {{ 'Reports.coverageReportDescription' | localize}}
                                        </span>
                                    </div>
                                </button>
                                <button
                                    class="agpr-reportCreateDialog-reportTypeButton"
                                    id="reportCreateDialog.comparisonReport"
                                    (click)="setCreateSingleSeriesReport(false)"
                                    [ngClass]="{'agpr-reportCreateDialog-reportTypeButton--active': !createSingleSeriesReport && !createCustomReport }"
                                >
                                    <span class="agpr-reportCreateDialog-reportTypeButtonIcon">
                                        <span class="agpr-i-line-reports-comparison" aria-hidden="true"></span>
                                    </span>
                                    <div
                                        class="agpr-reportCreateDialog-reportTypeButtonFlexContainer"
                                        [ngClass]="{'agpr-reportCreateDialog-reportTypeButtonFlexContainer--active': !createSingleSeriesReport && !createCustomReport }"
                                    >
                                        <span class="agpr-reportCreateDialog-reportTypeButtonLabel">
                                            {{ 'Reports.selectComparisonReport' | localize }}
                                        </span>
                                        <span class="agpr-reportCreateDialog-reportTypeButtonText">
                                            {{ 'Reports.comparisonReportDescription' | localize}}
                                        </span>
                                    </div>
                                </button>
                                <button
                                    class="agpr-reportCreateDialog-reportTypeButton"
                                    id="reportCreateDialog.customReport"
                                    (click)="setCreateCustomReport(true, false)"
                                    [ngClass]="{'agpr-reportCreateDialog-reportTypeButton--active': createCustomReport && !createSingleSeriesReport}"
                                >
                                    <span class="agpr-reportCreateDialog-reportTypeButtonIcon">
                                        <span class="agpr-i-line-reports-custom" aria-hidden="true"></span>
                                    </span>
                                    <div
                                        class="agpr-reportCreateDialog-reportTypeButtonFlexContainer"
                                        [ngClass]="{'agpr-reportCreateDialog-reportTypeButtonFlexContainer--active': createCustomReport && !createSingleSeriesReport }"
                                    >
                                        <span class="agpr-reportCreateDialog-reportTypeButtonLabel">
                                            {{ 'Reports.selectCustomReport' | localize }}
                                        </span>
                                        <span class="agpr-reportCreateDialog-reportTypeButtonText">
                                            {{ 'Reports.customReportDescription' | localize}}
                                        </span>
                                    </div>
                                </button>
                            </div>
                        </agpr-panel>
                        <!-- Select Charts Checkboxes -->
                        <div class="agpr-reportCreateDialog-newQuickReport-charts">
                            <agpr-panel
                                class="agpr-reportCreateDialog-newQuickReport-charts-singleSeries"
                                header="Reports.selectCharts"
                                [toggleable]="false"
                                [contentPadding]="false"
                            >
                                <ul [attr.aria-label]="'Reports.selectCharts' | localize">
                                    <li>
                                        <ul [attr.aria-label]="'Reports.quickReport.chart.singleSeries.label' | localize">
                                            <li
                                                *ngFor="let option of options; index as i"
                                                class="agpr-reportCreateDialog-newQuickReport-charts-option"
                                            >
                                                <agpr-checkbox
                                                    *ngIf="!option.multiSeries"
                                                    [id]="'singleSeriesChartOption_' + i"
                                                    [label]="option.label"
                                                    [value]="option"
                                                    [(ngModel)]="selectedCharts"
                                                    styleClass="agpr-checkboxFilter-checkbox"
                                                    (click)="setReportType()"
                                                ></agpr-checkbox>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="agpr-reportCreateDialog-newQuickReport-charts-multiSeries">
                                        <ul [attr.aria-label]="'Reports.quickReport.chart.multiSeries.label' | localize">
                                            <li
                                                *ngFor="let option of options; index as i"
                                                class="agpr-reportCreateDialog-newQuickReport-charts-option"
                                            >
                                                <agpr-checkbox
                                                    *ngIf="option.multiSeries"
                                                    [id]="'multiSeriesChartOption_' + i"
                                                    [label]="option.label"
                                                    [value]="option"
                                                    [(ngModel)]="selectedCharts"
                                                    styleClass="agpr-checkboxFilter-checkbox"
                                                    (click)="setReportType()"
                                                ></agpr-checkbox>
                                            </li>
                                        </ul>
                                    </li>

                                </ul>
                            </agpr-panel>
                        </div>
                    </div>
                    <div class="agpr-reportCreateDialog-quickReportSetup"
                        *ngIf="secondStep">
                        <!-- Quick Report Setup Panel -->
                        <div
                            class="agpr-quickReportSetup"
                            [id]="'quickReportSetup'"
                        >
                            <agpr-panel
                                class="agpr-quickReportSetup-leftPanel"
                                [header]="heading"
                                [toggleable]="false"
                                [contentPadding]="false"
                            >
                                <div class="agpr-quickReportSetup-report">
                                    <div class="agpr-quickReportSetup-reportFormField">
                                        <agpr-text-input
                                            [id]="'reportCreateDialog_reportTitle'"
                                            [maxLength]="64"
                                            [required]="true"
                                            [initialFocus]="true"
                                            [label]="'Reports.input.reportTitle'"
                                            [placeholder]="'Reports.input.reportTitle.placeholder' | localize"
                                            [ariaInvalid]="showError && !validReportTitle"
                                            [ariaDescribedBy]="'reportCreateDialog_reportTitle_invalidError'"
                                            [(ngModel)]="reportTitle"
                                            (ngModelChange)="validateForm()"
                                            [bottomMargin]="false"
                                        ></agpr-text-input>
                                        <agpr-form-message
                                            *ngIf="showError && !validReportTitle"
                                            id="reportCreateDialog_reportTitle_invalidError"
                                        >
                                            {{ 'Reports.input.reportTitle.error.required' | localize }}
                                        </agpr-form-message>
                                    </div>
                                    <div class="agpr-quickReportSetup-reportDateRange">
                                        <agpr-date-range-field
                                            [id]="'quickReportSetup'"
                                            [field]="dateRangeField"
                                            [value]="series"
                                            [icon]="hasDateRangeError ? 'fa-regular fa-duotone fa-circle-exclamation agpr-quickReportSetup-iconStyleClass' : null"
                                            [iconPopoverTemplate]="iconPopoverTemplate"
                                            [iconPopoverStyleClass]="'agpr-quickReportSetup-iconPopoverStyleClass'"
                                            [dateTypeOptions]="dateTypeOptions"
                                            (changes)="checkDateRangeError()"
                                        ></agpr-date-range-field>
                                        <ng-template #iconPopoverTemplate>
                                            <agpr-message
                                                [icon]="'agpr-i-line-warning'"
                                                [severity]="messageType.warning"
                                                [bottomMargin]="false"
                                            >
                                                {{ 'Reports.quickReportDialog.allDateRangeDisclaimer' | localize }}
                                            </agpr-message>
                                        </ng-template>
                                        <agpr-form-message *ngIf="!validDateRange">
                                            {{ 'Reports.quickReportDialog.error.invalidDateRange' | localize }}
                                        </agpr-form-message>
                                    </div>
                                </div>
                            </agpr-panel>
                            <div class="agpr-quickReportSetup-seriesPicker">
                                <div class="agpr-quickReportSetup-seriesPickerSingle">
                                    <agpr-series-picker-field
                                        [id]="'quickReportSetup'"
                                        [field]="singleSeriesField"
                                        [block]="singleSeriesBlock"
                                        [showContent]="singleSeriesChartSelected"
                                        [value]="singleSeries"
                                        [isNewReport]="true"
                                        [ariaInvalid]="showError && !validSeries"
                                        [ariaDescribedBy]="'reportCreateDialog_singleSeries_invalidError'"
                                        (changes)="singleSeriesChanged($event)"
                                    ></agpr-series-picker-field>
                                    <agpr-form-message
                                        *ngIf="showError && !validSeries"
                                        id="reportCreateDialog_singleSeries_invalidError"
                                    >
                                        {{ 'Reports.quickReportDialog.error.invalidSeries' | localize }}
                                    </agpr-form-message>
                                </div>
                                <div class="agpr-quickReportSetup-seriesPickerMulti">
                                    <agpr-series-picker-compare-field
                                        [id]="'quickReportSetup'"
                                        [field]="multiSeriesField"
                                        [value]="multiSeries"
                                        [block]="multiSeriesBlock"
                                        [showContent]="multiSeriesChartSelected"
                                        [isNewReport]="true"
                                        [ariaDescribedBy]="'reportCreateDialog_multiSeries_invalidError'"
                                        (changes)="multiSeriesChanged($event)"
                                    ></agpr-series-picker-compare-field>
                                    <agpr-form-message
                                        *ngIf="showError && !validMultiSeries"
                                        id="reportCreateDialog_multiSeries_invalidError"
                                    >
                                        {{ 'Reports.quickReportDialog.error.invalidSeries' | localize }}
                                    </agpr-form-message>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </agpr-tab>
            <agpr-tab
                [id]="'reportCreateDialog_blankReportTab'"
                [heading]="'Reports.blankReport'"
                [icon]="'fa-duotone fa-regular fa-file'"
                class="agpr-reportCreateDialog-blankReportTab"
            >
                <div class="agpr-reportCreateDialog-tabContent">
                    <div class="agpr-reportCreateDialog-newBlankReport">
                        <span class="agpr-reportCreateDialog-newBlankReportIcon">
                            <span class="agpr-i-line-report-new" aria-hidden="true"></span>
                        </span>
                        <span class="agpr-reportCreateDialog-newBlankReportText">
                            {{ 'Reports.startFromBlankReport' | localize }}
                        </span>
                        <span class="agpr-reportCreateDialog-newBlankReportHelperText">
                            {{ 'Reports.newReport.helperText' | localize }}
                        </span>
                    </div>
                </div>
            </agpr-tab>
            <agpr-tab
                [id]="'reportCreateDialog_copyReportTab'"
                [heading]="'Reports.pastReport'"
                [icon]="'fa-regular fa-duotone fa-clock-rotate-left'"
            >
                <div class="agpr-reportCreateDialog-tabContent">
                    <div class="agpr-reportCreateDialog-content-existingReportHeader">
                        {{ "Reports.chooseExistingReport" | localize }}
                    </div>
                    <agpr-list-filter-select
                        [id]="'reportCreateDialog'"
                        class="agpr-reportCreateDialog-existingReports"
                        [list]="reportListItems"
                        placeholder="Reports.reportFilterPlaceholder"
                        textInputAriaLabel="Reports.reportFilterPlaceholder"
                        listAriaLabel="Reports.existingReports"
                        (itemSelected)="onRowSelect($event)"
                    ></agpr-list-filter-select>
                </div>
            </agpr-tab>
        </agpr-tabs>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            label="Core.button.cancel"
            id="reportCreateDialog.cancelButton"
            [style]="buttonTypes.secondary"
            (click)="cancelClicked()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <!-- Button for create quick report -->
        <agpr-button
            *ngIf="createQuickReport && !secondStep"
            id="reportCreateDialog.nextStep"
            label="Reports.nextStep"
            [style]="buttonTypes.primary"
            [disabled]="createQuickReport && selectedCharts.length === 0"
            [tooltip]="createQuickReport && selectedCharts.length === 0 ? ('Reports.customReport.noCharts' | localize) : null"
            (click)="setQuickReportDialogState(true);"
        ></agpr-button>
        <agpr-button
            *ngIf="secondStep"
            (click)="showError=true;createNewQuickReport$.next()"
            id="quickReportSetup.createReport"
            label="Reports.quickReportDialog.createReport"
            [style]="buttonTypes.primary"
        ></agpr-button>
        <!-- Button for create new report -->
        <agpr-button
            *ngIf="!createFromPrevious && !createQuickReport"
            id="reportCreateDialog.createReport"
            label="Reports.createReport"
            [style]="buttonTypes.primary"
            (click)="createReport()"
        ></agpr-button>
        <!-- Button for create copy report -->
        <agpr-button
            *ngIf="createFromPrevious"
            id="reportCreateDialog.useSelectedButton"
            label="Reports.copyReportSelected"
            [style]="buttonTypes.primary"
            [disabled]="selectedReport === null"
            [tooltip]="selectedReport === null ? ('Reports.copyReport.noneSelected' | localize) : null"
            (click)="createReport()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>

